import store from '../../store'
import { fetchConfiguration } from '../../actions/configuration'

const ONE_HOUR = 1000 * 60 * 60
let intervalId = null

export function startConfigurationPolling() {
  // initial fetch
  store.dispatch(fetchConfiguration())

  // background polling
  intervalId = setInterval(() => {
    store.dispatch(fetchConfiguration())
  }, ONE_HOUR)
}

export function stopConfigurationPolling() {
  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
  }
}
